import React, {useEffect, useState} from 'react';
import style from "./ProductDetail.module.scss";
import {Carousel, Col, Image, Row, Space} from "antd";
import {useParams} from "react-router-dom";
import {getProductImage, getProductThumbnail} from "../../../../shared";
import {connect} from "react-redux";
import {withRouter} from "../../../../utils/services/with-router";
import {ProductImageProps} from "../../models";
import {
    LeftOutlined,
    RightOutlined,
    ZoomInOutlined,
    ZoomOutOutlined,
} from '@ant-design/icons';
import {StyledCarousel} from "./ProductDetail.styled";
const ProductImage = ({product} : ProductImageProps) => {
    const BaseURL = process.env.REACT_APP_IMAGES_URL;
    const [current, setCurrent] = React.useState(0);

    const { id } = useParams();
    const [productImage, setProductImage] =
        useState<any[]>([]);
    return (
        <Row justify={"center"} >
            <Col xs={20} sm={20} md={20} lg={20} xl={20}>
                    <StyledCarousel infinite={false} draggable={true} >
                        {
                            product?.productImages?.length ?
                                product?.productImages?.map((image: any, index:number) => (
                                    // <img className={style.customImage} alt={product?.name} loading={"lazy"}  src={`${BaseURL}/${image?.url}`}/>

                                    <Image.PreviewGroup
                                        items={product?.productImages?.map((image: any, index:number) =>
                                            `${BaseURL}/${image?.url}`
                                        )}
                                        preview={{
                                            toolbarRender: (
                                                _,
                                                {
                                                    transform: { scale },
                                                    actions: {
                                                        onActive,
                                                        onFlipY,
                                                        onFlipX,
                                                        onRotateLeft,
                                                        onRotateRight,
                                                        onZoomOut,
                                                        onZoomIn,
                                                        onReset,
                                                    },
                                                },
                                            ) => (
                                                <></>
                                            ),
                                            onChange: (index) => {
                                                setCurrent(index);
                                            },
                                        }}
                                    >
                                        <Image
                                            height={200}
                                            width={"100%"}
                                            key={index}
                                            className={style.customImage}
                                            title={product?.name}
                                            alt={product?.name}
                                            src={`${BaseURL}/${image?.url}`}
                                            preview={{
                                                mask: <span style={{ color: 'white' }}>مشاهده</span>,
                                            }}
                                        />
                                    </Image.PreviewGroup>

                                ))
                                : <img className={style.customImage} alt={product?.name} loading={"lazy"} src={require("assets/Logo/emptyImage.png")}/>
                        }
                    </StyledCarousel>
            </Col>
        </Row>
    );
};

export default connect(null, {getProductImage})(withRouter(ProductImage));
